function addCaregiver () {
    let url = window.location.origin
    window.open(url + `/caregivers/new`, '_blank');
    return true;
  }
  export default addCaregiver;